var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-backtop',{attrs:{"right":50,"bottom":100}},[_c('i',{staticClass:"el-icon-caret-top"})]),_c('keep-alive',{attrs:{"include":"News"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }